import { render, staticRenderFns } from "./TestSelect.vue?vue&type=template&id=666c89a7&"
import script from "./TestSelect.vue?vue&type=script&lang=ts&"
export * from "./TestSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports